import PropTypes from 'prop-types';
import styled from 'styled-components';
import { size, space } from '../../mixins';

const Box = styled.div`
  position: ${props => (props.relative ? 'relative' : 'static')};
  display: block;
  box-sizing: border-box;
  ${space};
  ${size};
  flex: ${props => props.flex || '0 1 auto'};
  word-wrap: break-word;
`;

Box.propTypes = {
  margin: PropTypes.string,
  m: PropTypes.string,
  my: PropTypes.string,
  mx: PropTypes.string,
  mt: PropTypes.string,
  mb: PropTypes.string,
  mr: PropTypes.string,
  ml: PropTypes.string,
  padding: PropTypes.string,
  p: PropTypes.string,
  py: PropTypes.string,
  px: PropTypes.string,
  pt: PropTypes.string,
  pb: PropTypes.string,
  pr: PropTypes.string,
  pl: PropTypes.string,
  width: PropTypes.string,
  w: PropTypes.string,
  height: PropTypes.string,
  h: PropTypes.string,
  flex: PropTypes.string
};

Box.defaultProps = {
  margin: null,
  m: null,
  my: null,
  mx: null,
  mt: null,
  mb: null,
  mr: null,
  ml: null,
  padding: null,
  p: null,
  py: null,
  px: null,
  pt: null,
  pb: null,
  pr: null,
  pl: null,
  width: null,
  w: null,
  height: null,
  h: null,
  flex: null
};

const Flex = styled(Box)`
  display: flex;
  flex-direction: ${props =>
    props.column
      ? props.reverse ? 'column-reverse' : 'column'
      : props.reverse ? 'row-reverse' : 'row'};
  justify-content: ${props => props.justify};
  align-items: ${props => props.align};
`;

Flex.propTypes = {
  column: PropTypes.bool,
  reverse: PropTypes.bool,
  justify: PropTypes.oneOf([
    'flex-start',
    'flex-end',
    'center',
    'space-between',
    'space-around'
  ]),
  align: PropTypes.oneOf([
    'stretch',
    'flex-start',
    'flex-end',
    'center',
    'baseline'
  ])
};

Flex.defaultProps = {
  column: false,
  reverse: false,
  justify: 'flex-start',
  align: 'stretch'
};

export { Box, Flex };



// WEBPACK FOOTER //
// ./src/components/units/Box/Box.js